import React from 'react';
import { queryCache } from 'react-query';
import { QKeys } from 'src/api/types';
import { GTCInlineWrapper } from 'src/components/GenericTable';
import { useGTPortalTarget } from 'src/components/GenericTable/GTContext';
import { MaturitySelect } from 'src/components/select';
import { MaturityLevel, useUpsertControlMutation } from 'src/graphql/_generated';
import { showSuccessToast, toastMessages } from 'src/components/Toast';
import { useAuth } from 'src/state/auth';

interface MaturityCellProps {
  controlId: string;
  field: 'existingMaturity' | 'targetMaturity';
  value: MaturityLevel | null | undefined;
}

export const MaturityCell: React.FC<MaturityCellProps> = ({ controlId, field, value }) => {
  const [upsertControl, { loading }] = useUpsertControlMutation();
  const { workspaceId } = useAuth();
  const portalTarget = useGTPortalTarget();

  const handleChange = (option: { value: MaturityLevel }) => {
    if (option.value === value) return;
    upsertControl({
      variables: {
        controlData: { id: controlId, [field]: option.value },
        workspaceId,
      },
      update: (cache) => {
        cache.modify({
          id: cache.identify({ __typename: 'Control', id: controlId }),
          fields: {
            [field]: () => option.value,
          },
        });
      },
      onCompleted: () => {
        queryCache.invalidateQueries([QKeys.Audit]);
        showSuccessToast(toastMessages.control.updated);
      },
    });
  };

  return (
    <GTCInlineWrapper>
      <MaturitySelect value={value} onChange={handleChange} disabled={loading} menuPortalTarget={portalTarget} />
    </GTCInlineWrapper>
  );
};
